let config =
{
    'appName'  : 'docset',
    'NODE_ENV' : process.env.REACT_APP_NODE_ENV,
    'dev'      : process.env.REACT_APP_NODE_ENV === 'development',
    'prod'     : process.env.REACT_APP_NODE_ENV === 'production',
    'test'     : process.env.REACT_APP_NODE_ENV === 'test',
    'debug'    : process.env.REACT_APP_DEBUG || false,
    'baseName' : process.env.REACT_APP_BASENAME || '',
    'api' : process.env.REACT_APP_API,
    'token': (localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).token) || '',
    'assetToken': (localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).token) || '',
    'version': 'api/',
    'headers': {
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `${process.env.REACT_APP_TOKEN || "Bearer"} ${(localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).token) || ''}`
    }
}

config.apiVersion = config.api+config.version;
config.apiReportVersion = config.report_api+config.version;

export default config